/* eslint-disable no-empty */
import pipe from 'ramda/es/pipe';
import create from 'zustand';
import { combine, devtools } from 'zustand/middleware';
import { UserTypeEnum } from '../utils';

const log = (config) => (set, get, api) =>
  config(
    (args) => {
      set(args);
    },
    get,
    api
  );

const createStore = pipe(log, create);

/**
 * userTokenStore
 */
const accessTokenKey = 'token';
const expiresInKey = 'expiresIn';

const getDefaultValues = () => {
  try {
    return {
      accessToken: localStorage.getItem(accessTokenKey) || '',
      expiresIn: localStorage.getItem(expiresInKey) || '',
    };
  } catch {
    return {
      accessToken: '',
      expiresIn: '',
    };
  }
};

export const useTokenStore = createStore(
  combine(getDefaultValues(), (set) => ({
    setTokens: (x) => {
      localStorage.setItem(accessTokenKey, x.accessToken);
      localStorage.setItem(expiresInKey, x.expiresIn);
      set(x);
    },
    clearTokens: () => {
      localStorage.removeItem(accessTokenKey);
      localStorage.removeItem(expiresInKey);
      set({ accessToken: '', expiresIn: '' });
    },
  }))
);

/**
 * USER STORE
 */
const user = {
  id: null,
  first_name: null,
  last_name: null,
  email: null,
  is_blocked: false,
  phone: null,
  company: null,
  position: null,
  user_type: UserTypeEnum.USER,
  created_at: null,
  updated_at: null,
  avatar_url: null,
};

export const useUserStore = createStore(
  combine(
    {
      user,
    },
    (set) => ({
      setUser: (u) => set({ user: u }),
      clearUser: () => set({ user }),
    })
  )
);

/**
 * SET TIMEZONE FROM PROGRAMS
 */

export const useSetTZProgram = createStore(
  combine(
    {
      from_program: false,
    },
    (set) => ({
      setTz: (p) => set({ from_program: p }),
    })
  )
);

/**
 * PROGRAM STORE
 */

// const program = {
//   name: '',
//   description: '',
//   fac_count: 1,
//   date: '',
//   time: '9:00 AM',
//   game_access: GameAccessEnum.HALF,
//   facilitators: [],
//   timezone: ''
// };

export const useProgramStore = createStore(
  combine(
    {
      program: {},
      programsList: [],
      allprogram: {},
      allPrograms: [],
    },
    devtools((set, get) => ({
      setProgram: (p) => set({ program: { ...get().program, ...p } }),
      clearProgram: () => set({ program: {} }),
      setAllProgramList: (allP) => set({ allPrograms: allP }),
      setProgramsList: (p) => set({ programsList: p }),
      clearProgramsList: () => set({ programsList: [] }),
    }))
  )
);

export const useGameConfigSetup = createStore(
  combine(
    {
      setup: {},
      setupList: [],
    },
    (set, get) => ({
      setSetup: (s) => set({ setup: { ...get().setup, ...s } }),
      clearSetup: () => set({ setup: {} }),
      setSetupList: (s) => set({ setupList: s }),
      clearSetupList: () => set({ setupList: [] }),
    })
  )
);
export const useGameConfigCalamity = createStore(
  combine(
    {
      calamity: {},
      calamityList: [],
    },
    (set, get) => ({
      setCalamity: (c) => set({ calamity: { ...get().calamity, ...c } }),
      clearCalamity: () => set({ calamity: {} }),
      setCalamityList: (c) => set({ calamityList: c }),
      clearCalamityList: () => set({ calamityList: [] }),
    })
  )
);

/**
 * facilitator
 */

export const useFacilitatorStore = createStore(
  combine(
    {
      facilitatorsList: [],
    },
    (set, get) => ({
      setFacilitatorsList: (c) => set({ facilitatorsList: c }),
      clearFacilitatorsList: () => set({ facilitatorsList: [] }),
    })
  )
);

/**
 * transactions
 */

export const useUserTransactions = createStore(
  combine(
    {
      transactionList: [],
    },
    (set) => ({
      setTransactionList: (t) => set({ transactionList: t }),
      clearTransactionList: () => set({ transactionList: [] }),
    })
  )
);

/**
 * check program date...
 */
export const useProgramDateCheckStore = createStore(
  combine(
    {
      result: false,
    },
    (set) => ({
      setCheck: (p) => set({ result: p }),
    })
  )
);

/**
 * user credits
 */

export const useCreditStore = createStore(
  combine(
    {
      half_cr: 0,
      full_cr: 0,
      trans: [],
    },
    (set) => ({
      setCredits: ({ half, full }) => set({ half_cr: half, full_cr: full }),
      setTrans: (t) => set({ trans: t }),
      setClear: () => set({ half_cr: 0, full_cr: 0, trans: [] }),
    })
  )
);
